<template>

    <div>
        <section class="max-w-screen-md">

            <div class="px-24" v-if="form.orderLoaded()">
                <svg xmlns="http://www.w3.org/2000/svg" class="mx-auto h-24 w-24 text-slate-400 text-teal-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" role="img" focusable="false" aria-labelledby="order-complete">
                    <title>Order Complete</title>
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>

                <h1 id="enter-code" class="text-center uppercase font-semibold mt-6 text-2xl">Congratulations</h1>

                <h2 class="text-center font-medium mt-2 mb-2 uppercase">We are processing your reward!</h2>

                <p class="text-slate-500 uppercase text-sm text-center mb-6">
                    (Processing can take up to 30 minutes)
                </p>

                <div class="my-10" v-for="item in form.order.items">
                    <img :src="item.image" :alt="item.sku" class="object-contain rounded-xl mx-auto h-56 mb-6">

                    <p class="text-center my-3 font-medium text-2xl border-b-2 border-slate-100 p-3">
                        Value: <span class="text-portal-primary">{{ f.formatCurrency(form.order.order_currency, item.value / 100)}}</span>
                    </p>
                </div>

                <p class="text-center text-slate-500 font-medium my-6">
                    <span class="uppercase">Your Order Reference</span> <span id="order-complete" class="text-slate-700 border-b border-slate-700">{{ form.order.reference }}</span>
                    <span class="block text-sm">Any issues? <a :href="`mailto:${app.support.address}`" target="_blank"> Contact Us</a></span>
                </p>

                <p class="text-center text-slate-500 font-medium my-6">
                    If you do not receive your gift card within a few minutes, please check your spam or junk mail folder.
                </p>

                <div class="col-span-6">
                    <div class="mt-2">
                        <router-link :to="{ name: 'redemption' }" class="btn w-full bg-portal-primary text-portal-secondary hover:bg-portal-primary-lighter">
                            Go Back
                        </router-link>
                    </div>
                </div>
            </div>

        </section>
    </div>

</template>

<script>
import {defineComponent} from "vue";
import {portal} from "../../app/Support/Props";
import Loading from "../Support/Loading";
import {Formatter} from "../../app/Support/Formatter";
import {OrderShow} from "../../app/Redemption/OrderShow";

export default defineComponent({
    props: portal,
    components: {Loading},
    data() {
        return {
            form: new OrderShow,
            f: new Formatter,
        }
    },
    mounted() {
        this.form.getOrder(this.$route.params.slug);
    }
});
</script>

